import React from 'react'
import { Box } from '@mui/joy'

const CellColor = ({ type = 'color', value}) => {
	return (
		<Box className={'list-element-cell cell-' + type}>
			<span className="color-dot" style={{ backgroundColor: value }}></span>
			<span className="color-label">{value}</span>
		</Box>
	)
}

export default CellColor